module.exports = NProgress;